import { gql } from 'apollo-boost'

export const WITH_DEP = gql`
  query userWitDepForChat($data: userWitDepForChat) {
    userWitDepForChat(data: $data)
  }
`
